import React, { useEffect, useState } from 'react'
import Axios from '../../../axios/axios';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import imageCompression from "browser-image-compression";
import SupplierNavbar from '../Admin/SuppplierNavbar';
import SupplierSidebar from '../Admin/SupplierSidebar';


function CreateSpareProduct() {
   const [spareModels, setSpareModels] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [spareRegion, setSpareRegion] = useState("");
  const [spareSeries, setSpareSeries] = useState("")
  const [productType, setProductTypeList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [catalogueFiles, setCatalogueFiles] = useState([]);
  const [spareSteering, setSpareSteering] = useState([]);
  const [spareBodyType, setSpareBodyType] = useState([]);
  const [spareTransmission, setSpareTransmission] = useState([]);
  const [spareModification, setSpareModification] = useState([]);
  const [spareEngine, setSpareEngine] = useState([]);
  const [spareEngineCode, setSpareEngineCode] = useState([]);
  const [spareGrade, setSpareGrade] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [years, setYears] = useState([])
  const [series, setSeries] = useState([])
  const [region, setRegion] = useState([])
  const [uploading, setUploading] = useState(false)
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState("");
  const [price, setPrice] = useState("");
  const [partNo, setPartNo] = useState("");
  const [description, setDescription] = useState("");
  const [suppliers, setSuppliers] = useState([]);
  const [formData, setFormData] = useState({ selectedSupplier: {} });
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  
    useEffect(() => {
      const storedSupplier = sessionStorage.getItem("supplierInfo");
      if (storedSupplier) {
        const supplierInfo = JSON.parse(storedSupplier);
        setSupplier(supplierInfo);
      }
    }, []);



  // const [image, setImage] = useState(null);
  const [images, setImages] = useState([]); 



  const [name, setName] = useState("");
  const navigate = useNavigate()

  useEffect(() => {
    getCompleteData()
    getItems();
    setYears(getYears());
  }, []);



  useEffect(() => {
    const fetchLoggedInSupplier = async () => {
      try {
        const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));
        
        if (!supplierInfo?.supplierId) {
          console.error('No supplier ID found');
          return;
        }
  
        const response = await Axios.get(`/supplier/get/${supplierInfo.supplierId}`);
        
        if (!response.data?.data) {
          console.error('No supplier data in response');
          return;
        }
  
        const apiData = response.data.data;
        console.log(apiData);
        
  
        setFormData(prev => ({
          ...prev,
          selectedSupplier: {
            _id: apiData._id,
            supplierName: apiData.supplierName || 'Not provided',
            address: apiData.address || 'Not provided',
            phoneNumber: apiData.phoneNumber || 'Not provided',
            emailAddress: apiData.emailAddress || 'Not provided'
          }
        }));
  
      } catch (error) {
        console.error('Error fetching supplier:', error);
      }
    };
  
    fetchLoggedInSupplier();
  }, []);

  const getCompleteData = async () => {
    Axios.get("/type-based-details").then((response) => {
      console.log("API Response:", response.data);
      setSpareModels(response.data.spare.models); //Set spare models
      setSpareBrand(response.data.spare.brands);
      setSpareCategory(response.data.spare.categories);
    })
      .catch((error) => console.error("Error fetching parts:", error));

  }

  const getItems = async () => {
    try {
      const result = await Axios.get(`/series`)
      const response = await Axios.get(`/regions`)
      console.log(result.data);
      setSeries(result.data)
      setRegion(response.data)


    } catch (error) {
      console.log(error);
    }
  }

  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const supplierData = formData.selectedSupplier;

  
    try {
      const formData = {
  name,
  partNo,
  modelId: selectedModel,
  brandId: selectedBrand,
  categoryId: selectedCategory,
  productType: selectedType,
  catalogue: catalogueFiles,
  steering: spareSteering,
  bodyType: spareBodyType,
  transmissionType: spareTransmission,
  modification: spareModification,
  engine: spareEngine,
  engineCode: spareEngineCode,
  seriesId: spareSeries,
  regionId: spareRegion,
  grade: spareGrade,
  images,
  year: selectedYear,
  price,
  description,
  supplier: {
          supplierId: supplierData._id,
          name: supplierData.supplierName,
          location: supplierData.address,
          contactNumber: supplierData.phoneNumber,
          email: supplierData.emailAddress,
        },
};

  
      const response = await Axios.post("/parts/create", formData);
      toast.success("Parts created successfully!");
      navigate("/SupplierProducts");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to create part");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSeries = (e) => {
    setSpareSeries(e.target.value);
  };

  const handleSelectRegion = (e) => {
    setSpareRegion(e.target.value);
  };

 
  const uploadFileHandler = async (e) => {
    const files = e.target.files; // Get all selected files
    if (!files || files.length === 0) return;
  
    setUploading(true);
  
    try {
      const uploadedImages = await Promise.all(
        Array.from(files).map(async (file) => {
          // Compress image (optional)
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 800,
          });
  
          const formData = new FormData();
          formData.append("image", compressedFile);
  
          const { data } = await Axios.post("/upload-multiple", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
  
          return {
            name: file.name,
            url: data.fileUrls[0], // Assuming backend returns URLs
            public_id: data.public_id, // For Cloudinary (optional)
          };
        })
      );
  
      setImages([...images, ...uploadedImages]); // Append new images
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };


  const removeImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1); // Remove image at index
    setImages(updatedImages);
  };


  const uploadCatalogueFileHandler = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    try {
      const formData = new FormData();
      formData.append('image', file); // Maintain the same field name for backend API compatibility
      setUploading(true);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await Axios.post('/upload-multiple', formData, config);
      console.log(data);

      setCatalogueFiles((prevFiles) => [
        ...prevFiles,
        {
          name: file.name,
          url: data.fileUrls[0], // Ensure the backend returns a file URL array
        },
      ]);

      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const removeCatalogueFile = (url) => {
    setCatalogueFiles(catalogueFiles.filter((file) => file.url !== url));
  };
  const getYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i);
  };

  useEffect(() => {
    const fetchProductType = async () => {
      try {
        const response = await Axios.get("/type-based-details");

        if (response.data && typeof response.data === "object") {
          // Map API response keys to match enum values
          const formattedTypes = Object.keys(response.data).map((type) => {
            if (type === "engineering") return "Engineering";
            if (type === "building") return "Building";
            if (type === "spare") return "Auto-Spare";
            return type; // Fallback
          });

          setProductTypeList(formattedTypes);
        } else {
          setProductTypeList([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching product type:", error);
        setProductTypeList([]); // Fallback to empty array
      }
    };

    fetchProductType();
  }, []);

  const handleChange = (e) => {
    setSelectedType(e.target.value);
  };
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await Axios.get("/supplier");
        setSuppliers(response.data.data);
      } catch (error) {
        console.error("Error fetching suppliers:", error.message);
      }
    };
    fetchSuppliers();
  }, []);
   const handleSupplierChange = (e) => {
  const supplierId = e.target.value;
  const supplier = suppliers.find((sup) => sup._id === supplierId);
  console.log("Selected Supplier:", supplier);
  setSelectedSupplier(supplier || {});
};







  return (
     <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}

          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
    <div className="row">
      <div className="col-12 grid-margin stretch-card ">
        <div className="card" style={{ maxHeight: '95vh', overflowY: 'auto', minHeight: '90vh' }}>

          <div className="card-body">
            <h4 className="card-title">Create Parts</h4>
            <form className="forms-sample" onSubmit={handleSubmit} >
              <div class="form-group">
                <label for="exampleInputName">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  // value={catDescription}
                  onChange={(e) => setName(e.target.value)} required
                />
              </div>

              <div className="form-group">
  <label htmlFor="exampleInputPartNo">Part Number</label>
  <input
    type="text"
    className="form-control"
    id="exampleInputPartNo"
    placeholder="Enter Part Number"
    value={partNo}
    onChange={(e) => setPartNo(e.target.value)}
    required
  />
</div>
<div className="form-group">
  <label htmlFor="exampleInputDescription">Description</label>
  <textarea
    className="form-control"
    id="exampleInputDescription"
    placeholder="Enter Description"
    value={description}
    onChange={(e) => setDescription(e.target.value)}
    rows={3}
    required
  ></textarea>
</div>


              <div className="form-group">
                <label>Brand</label>
                <select
                  className="form-control"
                  placeholder="select Brand"

                  value={selectedBrand}
                  onChange={(e) => setSelectedBrand(e.target.value)} required
                >
                  <option value="">Select Brand</option>
                  {spareBrand.map((brand) => (
                    <option value={brand._id}>
                      {brand.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className="form-group">
                <label>Model</label>
                <select
                  className="form-control"
                  placeholder="select model"

                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)} required
                >
                  <option value="">Select Model</option>
                  {spareModels.map((model) => (
                    <option value={model._id}>
                      {model.name}
                    </option>
                  ))}
                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Series</label>

                <select className='form-control'

                  value={spareSeries} onChange={handleSelectSeries} required>
                  <option value="">Select Series</option>
                  {series.map((item) => (

                    <option key={item?._id} value={item?._id}>{item.name}</option>
                  ))}

                </select>
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Region</label>

                <select className='form-control'

                  value={spareRegion} onChange={handleSelectRegion} required>
                  <option value="">Select Region</option>
                  {region.map((item) => (

                    <option key={item?._id} value={item?._id}>{item.name}</option>
                  ))}

                </select>
              </div>
              <div className="form-group">
                <label>Category</label>
                <select
                  className="form-control"
                  placeholder="select category"

                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  required
                  
                >
                  <option value="">Select Category</option>
                  {spareCategory.map((category) => (
                    <option value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="catalogueUpload">Catalogue Upload</label>
                <input
                  type="file"
                  className="form-control"
                  placeholder="upload catalogue"

                  accept=".pdf"
                  onChange={uploadCatalogueFileHandler}

                />

                {uploading && (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Uploading...</span>
                  </div>
                )}

                {catalogueFiles.map((file, index) => (
                  <div key={index} className="mt-2">
                    <a href={file.url} target="_blank" rel="noopener noreferrer">
                      {file.name}
                    </a>
                    {/* <button
                      className="btn btn-danger btn-sm ml-2"
                      onClick={() => removeCatalogueFile(file.url)}
                    >
                      Delete
                    </button> */}
                  </div>
                ))}
              </div>
              
              <div className="form-group">
      <label>Product Type</label>
      <select className="form-control" value={selectedType} onChange={handleChange}
      required>
        <option value="">Select Product Type</option>
        {/* Use dynamically fetched product types */}
        {productType.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
      </div>
                {/* Add Price Field */}
              <div className="form-group">
                <label htmlFor="exampleInputPrice">Price</label>
                <input
                  type="number"
                  className="form-control"
                  id="exampleInputPrice"
                  placeholder="Enter Price"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  required
                />
              </div>


             

<div className="form-group">
  <label>Images</label>
  <div className="d-flex align-items-center mb-2">
    <input
      type="file"
      id="image-upload"
      className="d-none"
      multiple // Allow multiple files
      onChange={uploadFileHandler}
      accept="image/*"
    />
    <label
      htmlFor="image-upload"
      className="btn btn-primary btn-sm mb-0"
    >
      <i className="icon-plus"></i> Add Images
    </label>
  </div>

  {/* Show uploading spinner */}
  {uploading && (
    <div className="spinner-border text-primary" role="status">
      <span className="sr-only">Uploading...</span>
    </div>
  )}

  {/* Display uploaded images */}
  <div className="d-flex flex-wrap gap-2 mt-2">
    {images.map((img, index) => (
      <div key={index} className="position-relative">
        <img
          src={img.url}
          alt={img.name}
          height="80"
          className="rounded border"
        />
        <button
          type="button"
          className="btn btn-danger btn-xs position-absolute top-0 end-0"
          onClick={() => removeImage(index)}
        >
          ×
        </button>
      </div>
    ))}
  </div>
</div>

              <div className="form-group">
                <label htmlFor="exampleInputPriority4">Steering</label>
                <select
                  className="form-control"

                  onChange={(e) => setSpareSteering(e.target.value)}
                  required
                >
                  <option value="">Select Steering</option>
                  <option value="speed-sensitive steering">SPEED-SENSITIVE STEERING</option>
                  <option value="four-wheel steering">FOUR-WHEEL STEERING</option>
                  <option value="power steering">POWER STEERING</option>

                </select>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputPriority4">BodyType</label>
                <select
                  className="form-control"
                  placeholder="select bodyType"

                  onChange={(e) => setSpareBodyType(e.target.value)}
                  required
                >
                  <option value="">Select BodyType</option>
                  <option value="hatchback">HATCHBACK</option>
                  <option value="MUV-SUV">MUV-SUV</option>
                  <option value="seden">SEDEN</option>

                </select>
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPriority4">TransmissionType</label>
                <select
                  className="form-control"
                  placeholder="select transmissionType"

                  onChange={(e) => setSpareTransmission(e.target.value)}
                  required
                >
                  <option value="">Select TransmissionType</option>
                  <option value="automatic">AUTOMATIC</option>
                  <option value="manual">MANUAL</option>

                </select>
              </div>


              <div className="form-group">
                <label>Year</label>
                <select
                  className="form-control"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  required
                >
                  <option value="" disabled>Select Year</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputPriority4">Modification</label>
                <select
                  className="form-control"
                  placeholder="select modification"
                  onChange={(e) => setSpareModification(e.target.value)}
                  required
                >
                  <option value="">Select Modification</option>
                  <option value="GXE10-AEPVK">GXE10-AEPVK</option>
                  <option value="JCE15W-AWPVF">JCE15W-AWPVF</option>
                  <option value="SXE10-AEAVF">SXE10-AEAVF</option>

                </select>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputPriority4">Engine</label>
                <select
                  className="form-control"
                  onChange={(e) => setSpareEngine(e.target.value)}
                  required
                >
                  <option value="">Select Engine</option>
                  <option value="flat engine">FLAT ENGINE</option>
                  <option value="v-engine">V-ENGINE</option>
                  <option value="twin-cylinder">TWIN-CYLINDER</option>

                </select>
              </div>


              <div className="form-group">
                <label htmlFor="exampleInputPriority4">Engine Code</label>
                <select
                  className="form-control"
                  onChange={(e) => setSpareEngineCode(e.target.value)}
                  required
                >
                  <option value="">Select EngineCode</option>
                  <option value="P1234">P1234</option>
                  <option value="p6345">P6345E</option>
                  <option value="p0987">P0987</option>

                </select>
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputPriority4">GRADE</label>
                <select
                  className="form-control"
                  onChange={(e) => setSpareGrade(e.target.value)}
                  required
                >
                  <option value="">Select Grade</option>
                  <option value="grade1">GRADE1</option>
                  <option value="grade2">GRADE2</option>
                  <option value="grade3">GRADE3</option>

                </select>
              </div>
    <div className="form-group">
             <label>Supplier</label>
            

              {/* Supplier Information (read-only) */}
  <input
    type="text"
    className="form-control mt-2"
    value={formData.selectedSupplier?.supplierName || "Loading..."}
    placeholder="Supplier Name"
    readOnly
  />
  <input
    type="text"
    className="form-control mt-2"
    value={formData.selectedSupplier?.address || ""}
    placeholder="Location"
    readOnly
  />
  <input
    type="text"
    className="form-control mt-2"
    value={formData.selectedSupplier?.phoneNumber || ""}
    placeholder="Contact Number"
    readOnly
  />
  <input
    type="email"
    className="form-control mt-2"
    value={formData.selectedSupplier?.emailAddress || ""}
    placeholder="Email"
    readOnly
  />
  

              </div>


              <div>

                <div className="bottom-area">
                  <p className="mt-14"></p>
                  <button type="submit" className="btn btn-primary mr-2" disabled={loading}>
                    {loading ? (
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    ) : (
                      "Submit"
                    )}
                  </button>
                  <Link to="/SupplierProducts">
                    <button className="btn btn-light">Cancel</button>
                  </Link>

                </div>
              </div>
              <div style={{ marginBottom: '60px' }}></div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
          </div>
        </div>
      </div>

  )
}

export default CreateSpareProduct
